import React from "react";
import PropTypes from "prop-types";
import Header from "components/Header/Header";
import Scrollbars from "components/Scrollbars/Scrollbars";
import "./Layout.scss";
import Footer from "components/Footer/Footer";


function Layout(props) {
  const { className } = props;

  return (
    <div className={`app-layout ${className}`} data-testid="layout">
      <Header/>
      <div className="app-content" data-testid="app-content">
        <Scrollbars>{props.children}</Scrollbars>
      </div>
      <Footer/>
    </div>
  );
}

Layout.propTypes = {
  className: PropTypes.string,
};

Layout.defaultProps = {
  className: "",
};

export default Layout;
